import React from 'react';
import LogoWhite from '../../images/logo-white.png';

export default function VideoLogo() {
  return <img src={LogoWhite} alt="logo" height={120} width={120} />;
}
